/* ===== Assessment Detail View ===== */

/* Grid-row expand/collapse */
.detailWrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.detailOpen {
  grid-template-rows: 1fr;
}

.detailInner {
  overflow: hidden;
}

.detailOpen .detailInner {
  padding-top: 12px;
}

/* Card */
.card {
  border: 1px solid var(--box-border-color, #e5e7eb);
  border-radius: 10px;
  background: var(--main-background, #fff);
  overflow: hidden;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.04),
    0 1px 2px rgba(0, 0, 0, 0.02);
}

/* ===== Section labels ===== */
.sectionLabel {
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--secondary-text, #9ca3af);
  margin: 0 0 8px 0;
}

/* ===== Analysis section (first, prominent) ===== */
.analysisSection {
  padding: 18px 20px;
  border-bottom: 1px solid var(--box-border-color, #e5e7eb);
}

.analysisContent {
  font-size: 0.88rem;
  color: var(--body-text, #374151);
  line-height: 1.7;
}

.analysisContent p {
  margin: 0 0 8px 0;
}

.analysisContent p:last-of-type {
  margin-bottom: 0;
}

/* ===== Metadata strip (horizontal, compact) ===== */
.metaStrip {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--box-border-color, #e5e7eb);
  background: var(--light-grey, #f9fafb);
}

.metaItem {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.metaKey {
  font-size: 0.68rem;
  font-weight: 500;
  color: var(--secondary-text, #9ca3af);
}

.metaValue {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--main-text, #1a1a1a);
}

/* Score display */
.scoreDisplay {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--main-text, #1a1a1a);
}

.scoreDot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Trajectory pill */
.trajectoryPill {
  display: inline-flex;
  align-items: center;
  font-size: 0.68rem;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 10px;
  background: var(--light-grey, #f3f4f6);
  border: 1px solid var(--box-border-color, #e5e7eb);
}

.trajectoryPill[data-trajectory="improving"] {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #059669;
}

.trajectoryPill[data-trajectory="worsening"] {
  background: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}

.trajectoryPill[data-trajectory="neutral"] {
  background: var(--light-grey, #f3f4f6);
  border-color: var(--box-border-color, #e5e7eb);
  color: var(--secondary-text, #6b7280);
}

/* ===== Company exposure ===== */
.exposureSection {
  padding: 14px 20px;
  border-top: 1px solid var(--box-border-color, #e5e7eb);
  background: var(--light-grey, #f9fafb);
}

.exposureHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exposureHeader .sectionLabel {
  margin-bottom: 0;
}

.editButton {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--accent-color, #2563eb);
  background: none;
  border: 1px solid var(--accent-color, #2563eb);
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 5px;
  transition:
    background 0.15s,
    color 0.15s;
}

.editButton:hover {
  background: var(--accent-color, #2563eb);
  color: #fff;
}

.exposureText {
  font-size: 0.8rem;
  color: var(--body-text, #555);
  line-height: 1.55;
  margin: 0;
  font-style: italic;
}

.exposurePlaceholder {
  font-size: 0.78rem;
  color: var(--secondary-text, #9ca3af);
  margin: 0;
  font-style: italic;
}

.editContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.editTextarea {
  font-family: inherit;
  font-size: 0.8rem;
  line-height: 1.55;
  color: var(--body-text, #374151);
  background: var(--main-background, #fff);
  border: 1px solid var(--box-border-color, #d1d5db);
  border-radius: 6px;
  padding: 8px 10px;
  resize: vertical;
  min-height: 60px;
  transition: border-color 0.15s;
}

.editTextarea:focus {
  outline: none;
  border-color: var(--accent-color, #2563eb);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.12);
}

.editActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.cancelButton,
.saveButton {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: 5px;
  cursor: pointer;
  transition:
    background 0.15s,
    opacity 0.15s;
}

.cancelButton {
  background: none;
  border: 1px solid var(--box-border-color, #d1d5db);
  color: var(--secondary-text, #6b7280);
}

.cancelButton:hover {
  background: var(--light-grey, #f3f4f6);
}

.saveButton {
  background: var(--accent-color, #2563eb);
  border: 1px solid var(--accent-color, #2563eb);
  color: #fff;
}

.saveButton:hover {
  opacity: 0.9;
}

.cancelButton:disabled,
.saveButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== Loading state ===== */
.loading {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.loadingBar {
  height: 10px;
  border-radius: 5px;
  background: linear-gradient(
    90deg,
    var(--box-border-color, #e5e7eb) 25%,
    var(--light-grey, #f3f4f6) 50%,
    var(--box-border-color, #e5e7eb) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  width: 80%;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
